module.exports = __webpack_public_path__ + "985d981f25dffa73881229a17cfa404f.svg";